import { FC, ReactNode } from 'react';

import getClassNames from '../../utils/getClassNames';
import style from './Navigation.module.scss';

type TopNavItemWrapperProps = {
  children: ReactNode;
  classNameModifier?: string;
};

const TopNavItemWrapper: FC<TopNavItemWrapperProps> = ({
  children,
  classNameModifier,
}) => (
  <li className={getClassNames(style, 'item', classNameModifier)}>
    {children}
  </li>
);

export default TopNavItemWrapper;
